import { render, staticRenderFns } from "./repairtask.vue?vue&type=template&id=274b17ca&scoped=true&"
import script from "./repairtask.vue?vue&type=script&lang=js&"
export * from "./repairtask.vue?vue&type=script&lang=js&"
import style0 from "./repairtask.vue?vue&type=style&index=0&id=274b17ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b17ca",
  null
  
)

export default component.exports